import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";

function UsersRule({ users, rule, errors, attributes, setAttributes }) {
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item style={{ textAlign: "right", width: "20%" }}>
        Usuários
      </Grid>

      <Grid item style={{ width: "50%" }}>
        <Autocomplete
          defaultValue={users?.filter((user) =>
            rule?.user_ids?.includes(user.id)
          )}
          style={{ marginTop: 20 }}
          options={users}
          disableCloseOnSelect
          openOnFocus={true}
          multiple
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              label="Usuários"
              variant="outlined"
              helperText={errors.usersOrCompanyTeam}
            />
          )}
          onChange={(_event, value) =>
            setAttributes({
              ...attributes,
              users: value.map((v) => v.id),
            })
          }
          getOptionLabel={(field) => `${field.name} \n (${field.email})`}
          getOptionSelected={(option, value) => option.id === value.id}
        />
      </Grid>
    </Grid>
  );
}

export default UsersRule;
